export const CONFIGURE_SESSION = 'CONFIGURE_SESSION';
export const LOGOUT = 'LOGOUT';
export const POPULATE_SETTINGS = 'POPULATE_SETTINGS';
